import * as React from "react"
import { cn } from "@/lib/utils"

export function Section({
  id,
  className,
  containerClassName,
  children,
}: {
  id?: string
  className?: string
  containerClassName?: string
  children: React.ReactNode
}) {
  return (
    <section id={id} className={cn("py-20 sm:py-28", className)}>
      <div className={cn("mx-auto max-w-6xl px-4 sm:px-6", containerClassName)}>
        {children}
      </div>
    </section>
  )
}

export function Eyebrow({ children }: { children: React.ReactNode }) {
  return (
    <span className="text-xs font-semibold uppercase tracking-[0.18em] text-accent-display">
      {children}
    </span>
  )
}
